<div class="sectionContainer paddedContent">
  <div class="formRow">
    <app-check-input
      [label]="'Beneficial Owner'"
      [readonly]="false"
    ></app-check-input>
    <app-check-input
      [label]="'Responsible Party'"
      [readonly]="false"
    ></app-check-input>
    <app-check-input
      [label]="'Authorized Signer'"
      [readonly]="false"
    ></app-check-input>
  </div>
  <div class="formRow">
    <app-text-input
      [label]="'Benficial Ownership'"
      [type]="inputTextModes.Percent"
      [readonly]="false"
    ></app-text-input>
    <app-text-input [label]="'Title'" [readonly]="false"></app-text-input>
  </div>
  <div class="formRow">
    <app-text-input [label]="'First Name'" [readonly]="false"></app-text-input>
    <app-text-input [label]="'Last Name'" [readonly]="false"></app-text-input>
    <app-text-input
      [label]="'Date of birth'"
      [type]="inputTextModes.Date"
      [hint]="'yyyy/mm/dd'"
      [readonly]="false"
    ></app-text-input>
  </div>
  <div class="formRow">
    <app-text-input [label]="'Address'" [readonly]="false"></app-text-input>
  </div>
  <div class="formRow">
    <app-text-input [label]="'City'" [readonly]="false"></app-text-input>
    <app-text-input [label]="'State'" [readonly]="false"></app-text-input>
    <app-text-input [label]="'Zip'" [readonly]="false"></app-text-input>
    <app-text-input [label]="'Country'" [readonly]="false"></app-text-input>
  </div>
  <div class="formRow">
    <app-text-input
      [label]="'Phone'"
      [type]="inputTextModes.Phone"
      [readonly]="false"
    ></app-text-input>
    <app-text-input [label]="'SSN'" [readonly]="false"></app-text-input>
    <app-text-input
      [label]="'Email'"
      [type]="inputTextModes.Email"
      [readonly]="false"
    ></app-text-input>
  </div>
  <div class="formRow">
    <app-text-input
      [label]="'DL Number'"
      [type]="inputTextModes.Phone"
      [readonly]="false"
    ></app-text-input>
    <app-text-input
      [label]="'DL Issue State'"
      [readonly]="false"
    ></app-text-input>
    <app-text-input
      [label]="'DL Issue Date'"
      [readonly]="false"
    ></app-text-input>
    <app-text-input
      [label]="'DL Expiration'"
      [readonly]="false"
    ></app-text-input>
  </div>

  <div style="text-align: center">
    <input
      type="button"
      class="button_secondary button_var_2 button_right-spacing"
      value="Save"
      (click)="btnSave_click()"
    />
    <input
      type="button"
      class="button_secondary button_var_2"
      value="Cancel"
      (click)="btnClose_click()"
    />
  </div>
</div>
